import React from "react";
import { Box, FormControl, Select, MenuItem } from "@mui/material";

export const PaginationDropdown = ({
  rows,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50],
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <FormControl
        sx={{
          m: 1,
          minWidth: 50,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
        }}
        size="small"
      >
        <Select value={rows} onChange={onRowsPerPageChange}>
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option} / page
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
